import { AppBar, Box } from '@mui/material';
import { InsightLogo } from '../logos';
import ServiceDeskLink from '../ServiceDeskLink';
import { ColoredToolbar } from './colored-toolbar';

export function HeaderPublic() {
  return (
    <AppBar position='static'>
      <ColoredToolbar>
        <Box display='flex' flex='1' justifyContent='start'>
          <InsightLogo />
        </Box>
        <Box display='flex' flex='1' justifyContent='center'></Box>
        <Box display='flex' flex='1' justifyContent='end'>
          <ServiceDeskLink />
        </Box>
      </ColoredToolbar>
    </AppBar>
  );
}
